import { render, staticRenderFns } from "./KpiTable.vue?vue&type=template&id=75f30fcd&scoped=true&"
import script from "./KpiTable.vue?vue&type=script&lang=js&"
export * from "./KpiTable.vue?vue&type=script&lang=js&"
import style0 from "./KpiTable.vue?vue&type=style&index=0&id=75f30fcd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f30fcd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
